// common
import '@ungap/custom-elements' // fix safari
import './fix-scrollbar-width'
import './menu'
import './scrolled'
import './sliders'
import './photos'

// blocks
import './blocks/cas-client'

// eslint-disable-next-line no-console
console.log('Ok ! ')
